import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import { ApprovalList, EvaluationReport, Hike } from 'src/app/shared/models/appraisal';
import { Context } from 'src/app/shared/models/context';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';

@Component({
  selector: 'app-evaluation-slip',
  templateUrl: './evaluation-slip.component.html',
  styleUrls: ['./evaluation-slip.component.scss']
})
export class EvaluationSlipComponent implements OnInit {
  @Input() activeAppraisalId: number;
  @Input() context: Context;
  @Input() assessmentData: EvaluationReport;
  public hikes: Hike[];
  public hikeValue: number;
  constructor(
    public activeModal: NgbActiveModal,
    private appraisalService: ApparaisalService,
  ) { }

  ngOnInit(): void {
    if (this.hikes?.length > 0) {
      this.hikeValue = this.hikes[0].value || 0;
  }
  this.getHike(this.assessmentData.assessmentDto.id)
  }
  private getHike(id: number) {
    this.appraisalService.getHike(id).subscribe(hikes => {
        this.hikes = hikes;
        if (this.hikes && this.hikes.length > 0) {
            this.hikeValue = this.hikes[0].value || 0;
        }
    });
}
  public downloadImage() {
    const element = document.getElementById('evaluation-content');
    if (element) {
      html2canvas(element).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'evaluation report.png';
        link.click();
      });
    }
  }
}
